module.exports = __webpack_public_path__ + "static/media/drink_promo.7230f034.jpg";